import React from 'react';
import { dynaMount } from '../utils/mountComponent';
import BoostBanner, { BoostBannerProps } from './BoostBanner';

export const BOOST_BANNER_PREVIEW = 'listings-root__boost-banner-preview';

const BoostBannerRoot = (
    props: BoostBannerProps,
): JSX.Element | React.ReactPortal | null =>
    dynaMount(
        {
            Component: BoostBanner,
            containerId: BOOST_BANNER_PREVIEW,
        },
        { ...props },
    );

export default BoostBannerRoot;
